import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 56 56' fill={fillColor} className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path d='m38,0l-2,0l-16,0l-2,0l-18,0l0,56l18,0l2,0l16,0l2,0l18,0l0,-56l-18,0zm-20,54l-16,0l0,-52l16,0l0,52zm18,0l-16,0l0,-52l16,0l0,52zm18,0l-16,0l0,-52l16,0l0,52z' />
        <path d='m16,4l-12,0l0,22l12,0l0,-22zm-2,20l-8,0l0,-18l8,0l0,18z' />
        <path d='m34,4l-12,0l0,22l12,0l0,-22zm-2,20l-8,0l0,-18l8,0l0,18z' />
        <path d='m52,4l-12,0l0,22l12,0l0,-22zm-2,20l-8,0l0,-18l8,0l0,18z' />
        <path d='m10,51c3.309,0 6,-2.691 6,-6s-2.691,-6 -6,-6s-6,2.691 -6,6s2.691,6 6,6zm0,-10c2.206,0 4,1.794 4,4s-1.794,4 -4,4s-4,-1.794 -4,-4s1.794,-4 4,-4z' />
        <path d='m28,51c3.309,0 6,-2.691 6,-6s-2.691,-6 -6,-6s-6,2.691 -6,6s2.691,6 6,6zm0,-10c2.206,0 4,1.794 4,4s-1.794,4 -4,4s-4,-1.794 -4,-4s1.794,-4 4,-4z' />
        <path d='m46,51c3.309,0 6,-2.691 6,-6s-2.691,-6 -6,-6s-6,2.691 -6,6s2.691,6 6,6zm0,-10c2.206,0 4,1.794 4,4s-1.794,4 -4,4s-4,-1.794 -4,-4s1.794,-4 4,-4z' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
